import { render, staticRenderFns } from "./ChangeTeamZoneConfirmation.vue?vue&type=template&id=0941506c&"
import script from "./ChangeTeamZoneConfirmation.vue?vue&type=script&lang=js&"
export * from "./ChangeTeamZoneConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports